import { createFileRoute } from '@tanstack/react-router';

import { DemandDefinitionsPage } from '../demand-definition/pages/DemandDefinitionsPage';

export const Route = createFileRoute('/_app/demand-definitions/')({
    component: DemandDefinitionsPage,
});
